export default {
      MyOrders: 'الطلب الفعال|طلباتي الفعالة',
      MyOrders_no_body: 'طلب فعال',
};
